import React, { forwardRef, isValidElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ToastContext } from '../Toast/ToastContext';
import { st, classes } from './ToastContainer.st.css.js';
const MAX_VISIBLE_TOASTS = 3;
const toastTransition = {
    duration: 0.3,
    ease: [0, 0, 0.2, 1],
};
const toastInitialState = {
    translateY: '100%',
    opacity: 0,
};
const toastVisibleState = {
    translateY: '0%',
    opacity: 1,
};
const toastHiddenState = {
    translateY: '0%',
    opacity: 0,
};
const toastExitedState = {
    translateY: '0%',
    opacity: 0,
    transition: {
        duration: 0.3,
        ease: [0.4, 0, 1, 1],
    },
};
const ToastContainer = forwardRef(({ offset, zIndex, dataHook, className, children }, ref) => {
    const toasts = React.Children.toArray(children).reverse();
    return (React.createElement("div", { ref: ref, className: st(classes.root, className), "data-hook": dataHook, style: { bottom: offset, zIndex } },
        React.createElement(AnimatePresence, null, toasts.map((toast, index) => {
            if (!isValidElement(toast)) {
                return null;
            }
            const hidden = index >= MAX_VISIBLE_TOASTS;
            const containerKey = `toast-container-${toast.key}`;
            return (React.createElement(motion.div, { key: containerKey, "data-hook": containerKey, "data-hidden": hidden, layout: true, transition: toastTransition, initial: toastInitialState, animate: hidden ? toastHiddenState : toastVisibleState, exit: toastExitedState, style: { pointerEvents: hidden ? 'none' : undefined } },
                React.createElement(ToastContext.Provider, { value: { hidden } }, toast)));
        }))));
});
export default ToastContainer;
//# sourceMappingURL=ToastContainer.js.map